'use strict';

angular.module('msWidgets').directive('msWidgetButtonBackButton', [function () {
  return {
    templateUrl: 'widgets/templates/button/back_button.html'
  };
}]).directive('msWidgetButtonBranchingCards', [function () {
  return {
    templateUrl: 'widgets/templates/button/branching_cards.html'
  };
}]).directive('msWidgetButtonDoneButton', [function () {
  return {
    templateUrl: 'widgets/templates/button/done_button.html'
  };
}]).directive('msWidgetButtonDonePrevButton', [function () {
  return {
    templateUrl: 'widgets/templates/button/done_prev_button.html'
  };
}]).directive('msWidgetButtonNextButton', [function () {
  return {
    templateUrl: 'widgets/templates/button/next_button.html'
  };
}]).directive('msWidgetButtonNextPrevButton', [function () {
  return {
    templateUrl: 'widgets/templates/button/next_prev_button.html'
  };
}]).directive('msWidgetButtonRevealButtonsImg', [function () {
  return {
    templateUrl: 'widgets/templates/button/reveal_buttons_img.html',
    controller: 'NonSequentialRevealCtrl',
    controllerAs: '$ctrl'
  };
}]);